import { createContext } from "react";

// Filled only during the build-time prerender; null in the browser.
export const PrerenderData = createContext(null);
